import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NoFindZxb from '@/components/no-find-zxb.vue';
import DarkBg from '@/components/dark-bg.vue';
import DarkBgCopy from '@/components/dark-bg-copy.vue';
import InputCode from '@/components/input-code.vue';
import iframeServer from '@/views/iframe-server/index';
import { getCodeUrlMixins } from '@/utils/getCodeUrlMixin.js';
import { getByteLenAndSlice } from '@/utils/validate';
import { debounce } from '@/utils/tools';
import { mapGetters } from 'vuex';
import { resourceBury } from '@/api/modules/bury.js';
export default {
  name: 'VideoIframe',
  components: {
    DarkBg: DarkBg,
    DarkBgCopy: DarkBgCopy,
    iframeServer: iframeServer,
    InputCode: InputCode
  },
  mixins: [getCodeUrlMixins],
  props: {
    showDialog: {
      type: Boolean
    },
    title: {
      type: String,
      default: ''
    },
    showInputCode: {
      type: Boolean,
      default: true
    },
    tabs: {
      type: Object,
      default: function _default() {}
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var edu = JSON.parse(localStorage.getItem('userInfo')).edu;
    return {
      dialogVisible: this.showDialog,
      iframeUrl: '',
      count: 0,
      edu: edu,
      businessKey: '',
      iframeResult: {},
      saveVideoId: {},
      currentModuleType: {},
      showTabs: false,
      showGuideHint: false,
      dialogScrollTop: false,
      // 如果是加载视频，超过一屏幕了，让弹框吸顶
      isFullScreen: false,
      dialogHeight: '',
      clientWidth: 1200
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['userActionNewZxbInfo'])), {}, {
    fascicleImg: function fascicleImg() {
      // { 1: '学习', 2: '练习' }
      var preciousType = this.iframeResult.preciousType;

      if (preciousType === 1) {
        return this.$resource('img-guide-study.png');
      } else if (preciousType === 2) {
        return this.$resource('img-guide-practice.png');
      }

      return '';
    },
    outlineName: function outlineName() {
      var name = this.iframeResult.appOutlineName || this.iframeResult.outlineName;

      var _getByteLenAndSlice = getByteLenAndSlice(name, 66),
          sliceStr = _getByteLenAndSlice.sliceStr,
          len = _getByteLenAndSlice.len;

      if (len > 66) {
        return "".concat(sliceStr, "\xB7\xB7\xB7");
      }

      return name;
    },
    notVideoDialog: function notVideoDialog() {
      if (this.dialogScrollTop) {
        return this.currentModuleType !== 1 ? 'not-video-dialog' : 'dialog-scrollTop';
      }

      return this.currentModuleType !== 1 ? 'not-video-dialog' : '';
    },
    guideText: function guideText() {
      var text = {
        1: "\u7B2C".concat(this.iframeResult.page, "\u9875\u6709\u591A\u4E2A\u5361\u7247\uFF0C\u70B9\u51FB\u8FD9\u91CC\uFF0C\u5207\u6362\u4F60\u60F3\u5B66\u4E60\u7684\u5361\u7247"),
        2: "\u6CE8\u610F\u54E6\uFF0C\u8FD9\u6709\u591A\u4E2A\u5361\u7247\uFF0C\u5728\u8FD9\u91CC\u53EF\u4EE5\u5207\u6362"
      };
      return text[this.iframeResult.guideType];
    }
  }),
  watch: {
    tabs: {
      handler: function handler(val) {
        this.init(val);
      },
      deep: true,
      immediate: true
    },
    showGuideHint: function showGuideHint(val) {
      if (!val && this.currentModuleType === 1) {
        // 是视频且引导弹框关闭时让视频自动播放
        // this.iframeUrl = `${this.iframeUrl.split('&autoPlay')[0]}&autoPlay=1`
        var serviceIframe = document.getElementById('serviceIframe');
        var iframeWin = serviceIframe ? serviceIframe.contentWindow : null;

        if (iframeWin) {
          iframeWin.postMessage({
            eventName: 'videoPlay'
          }, '*');
        }
      }
    }
  },
  created: function created() {
    window.addEventListener('message', this.lookNote);
    window.addEventListener('resize', debounce(this.setDialogScrollTop, 300));
    this.$store.dispatch('closeInteractionCodeDialog', false);

    if (sessionStorage.preciousType) {
      // 点击提交的练习宝和历史记录的练习宝时走这里
      var preciousType = sessionStorage.preciousType;
      sessionStorage.removeItem('preciousType');
      this.showTabs = preciousType === '1';
    }
  },
  methods: {
    setDialogScrollTop: function setDialogScrollTop() {
      var _this$$refs$myDialog, _this$$refs$myDialog2;

      this.clientWidth = document.body.clientWidth;
      this.dialogHeight = this === null || this === void 0 ? void 0 : (_this$$refs$myDialog = this.$refs.myDialog) === null || _this$$refs$myDialog === void 0 ? void 0 : _this$$refs$myDialog.$refs.dialog.offsetHeight;
      this.dialogScrollTop = (this === null || this === void 0 ? void 0 : (_this$$refs$myDialog2 = this.$refs.myDialog) === null || _this$$refs$myDialog2 === void 0 ? void 0 : _this$$refs$myDialog2.$refs.dialog.offsetHeight) > document.body.clientHeight;
    },
    toResourceBury: function toResourceBury(currentTab, obtainMethod) {
      var params = {
        buryEventType: 'obtain function_card',
        buryEventId: 1,
        businessId: currentTab.businessId + '',
        // 兼容tabs接口返回的number类型
        businessType: currentTab.businessType,
        moduleType: currentTab.moduleType,
        obtainMethod: obtainMethod || this.iframeResult.obtainMethod
      };
      resourceBury(params);
    },
    lookNote: function lookNote(_ref) {
      var data = _ref.data;

      if ((data === null || data === void 0 ? void 0 : data.eventName) === 'showNote') {
        // 看完视频以后点击查看笔记，跳转到笔记
        this.isFullScreen = false;
        this.businessKey = data.businessId + '笔记';
        this.iframeUrl = "".concat(this.baseUrl, "/webviewpad/answerNote?businessId=").concat(data.businessId, "&businessType=").concat(data.businessType, "&source=searchCode&businessSource=ffhz-frontend-book");
        this.currentModuleType = 2;
      }

      if ((data === null || data === void 0 ? void 0 : data.eventName) === 'videoChange') {
        // 在视频里能选集，切页签之后再切回来要记住之前看的是第几个视频
        this.saveVideoId[this.businessKey] = data.preciousInteractiveVideoId;
      }

      if ((data === null || data === void 0 ? void 0 : data.eventName) === 'setFullScreen') {
        this.isFullScreen = data === null || data === void 0 ? void 0 : data.fullScreen;
      }
    },
    init: function init(val) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this$$refs$myDialog3;

        var labelContentEle, currentTab, videoId;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                labelContentEle = document.getElementsByClassName('label-content');
                labelContentEle.length > 0 && (labelContentEle[0].scrollTop = 0);
                _this.iframeResult = val;
                _this.showGuideHint = _this.iframeResult.guideType && _this.iframeResult.guideType !== 0;
                _this.showTabs = _this.iframeResult.preciousType !== 2;
                currentTab = val.tabList.find(function (item) {
                  return item.selected;
                });
                _this.businessKey = currentTab.businessId + currentTab.contentName;
                videoId = _this.saveVideoId[_this.businessKey] || 1;

                if (currentTab.moduleType === 1) {
                  // moduleType=1是视频
                  // this.iframeUrl = this.showGuideHint ? `${currentTab.h5Url}&preciousInteractiveVideoId=${videoId}&autoPlay=2` : `${currentTab.h5Url}&preciousInteractiveVideoId=${videoId}`
                  _this.iframeUrl = _this.showGuideHint ? "".concat(currentTab.h5Url, "&preciousInteractiveVideoId=").concat(videoId, "&initPause=1&showWebFullScreenBtn=1&businessSource=ffhz-frontend-book") : "".concat(currentTab.h5Url, "&preciousInteractiveVideoId=").concat(videoId, "&showWebFullScreenBtn=1&businessSource=ffhz-frontend-book");
                } else {
                  _this.iframeUrl = currentTab.h5Url;
                }

                _this.currentModuleType = currentTab.moduleType;
                _context.next = 12;
                return _this.$nextTick();

              case 12:
                _this.dialogHeight = _this === null || _this === void 0 ? void 0 : (_this$$refs$myDialog3 = _this.$refs.myDialog) === null || _this$$refs$myDialog3 === void 0 ? void 0 : _this$$refs$myDialog3.$refs.dialog.offsetHeight;
                _this.dialogScrollTop = _this.$refs.myDialog.$refs.dialog.offsetHeight > document.body.clientHeight;
                _this.$refs[_this.businessKey] && _this.$refs[_this.businessKey][0].scrollIntoView(false);

                _this.toResourceBury(currentTab);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    toggleGroup: function toggleGroup(tab) {
      this.toResourceBury(tab, 5);

      if (this.showGuideHint) {
        this.showGuideHint = false;
      }

      this.businessKey = tab.businessId + tab.contentName;
      var videoId = this.saveVideoId[this.businessKey] || 1;
      this.iframeUrl = tab.moduleType === 1 ? "".concat(tab.h5Url, "&preciousInteractiveVideoId=").concat(videoId, "&showWebFullScreenBtn=1&businessSource=ffhz-frontend-book") : tab.h5Url;
      this.currentModuleType = tab.moduleType;
    },
    handleShowiframeDialog: function handleShowiframeDialog(params) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$_this2$getCode, result;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.getCodeTurn(_objectSpread({
                  obtainMethod: 2
                }, params));

              case 2:
                _yield$_this2$getCode = _context2.sent;
                result = _yield$_this2$getCode.result;

                if (result) {
                  _context2.next = 7;
                  break;
                }

                _this2.$showModal(NoFindZxb, {}, {
                  noFooter: true,
                  width: '784px',
                  customClass: 'no-find-dialog'
                });

                return _context2.abrupt("return");

              case 7:
                _this2.saveVideoId = {}; // 重新输入页码了，把之前存的视频id清掉

                _this2.init(result);

                _this2.count++;

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    handleClose: function handleClose(data) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this3.userActionNewZxbInfo) {
                  // 在弹框里手动改过才会有这个值，没有就不改
                  _this3.$store.dispatch('setSubject', _this3.userActionNewZxbInfo.subjectCode);

                  _this3.$store.dispatch('setPreciousInfo', _this3.userActionNewZxbInfo.preciousInfo);

                  _this3.$store.dispatch('toUpdatePreciousInfo', null);
                }

                _this3.$emit('update:showDialog', false);

                _this3.$store.dispatch('closeInteractionCodeDialog', true); // 关闭弹框要通知各个页面更新数据


              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};